import axios from 'axios'

const getData = async (endpoint) => {
    const {data} = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}${endpoint}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        
    return data
}

const allowNumberInputs = (value) => {
  let newValue = ""
  for(let no = 0; no < value.length; no++){
    if(value[no] <= 9 && value[no] >= 0){
      newValue += value[no]
    }
  }
  return newValue
}

export { getData, allowNumberInputs }